import { Typography } from '@mui/material'

import { PanelBox } from '../default'
import { ApplicationServicesTable } from '../tables'

/**
 * @description Renders a panel for managing applications.
 *
 * @author Maria Eduarda Franke
 * @returns {React.Component} The rendered component.
 */
const ApplicationServicesPanel = () => {

    return (
        <PanelBox>
            <Typography variant="h5" fontWeight="bold" sx={{ mb: 3 }}>
                Gerenciar Aplicações
            </Typography>
            <ApplicationServicesTable />
        </PanelBox>
    )
}

export default ApplicationServicesPanel